import { useMutation } from "@tanstack/react-query";
import { deleteFloorPlanMemoDiagram } from "~/_legacy/apis/delete-floor-plan-memo-diagram";
import { isNullish } from "~/_legacy/utils/compare";

export const DELETE_FLOOR_PLAN_MEMO_DIAGRAM_MUTATION_KEY = "deleteFloorPlanMemoDiagram";

export function useDeleteFloorPlanMemoDiagram({
  branchUid,
  branchVersionId,
}: {
  branchUid?: string;
  branchVersionId?: number;
}) {
  const { mutateAsync } = useMutation({
    mutationKey: [DELETE_FLOOR_PLAN_MEMO_DIAGRAM_MUTATION_KEY, branchUid, branchVersionId],
    mutationFn: ({
      floorPlanId,
      memoDiagramId,
    }: {
      floorPlanId: number;
      memoDiagramId: number;
    }) => {
      if (isNullish(branchUid)) {
        throw new Error("Branch uid가 필요합니다.");
      }
      return deleteFloorPlanMemoDiagram({
        branchUid,
        branchVersionId,
        floorPlanId,
        memoDiagramId,
      });
    },
  });

  return {
    deleteFloorPlanMemoDiagram: mutateAsync,
  };
}
